export default "__VITE_ASSET__wcnPDJvY__"